var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-progress-bar",class:_vm.backgroundColor,style:({ width: _vm.width + 'rem'})},[_c('div',{staticClass:"progress-bar",class:_vm.progressColor,style:(_vm.progressBarStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }